import { Builder } from '@builder.io/react'
import { Cache } from 'aws-amplify'
import React, { useEffect } from 'react'

interface DiscountCodeProps {
  code: string | null
}

export default function DiscountCode({ code }: DiscountCodeProps) {
  useEffect(() => {
    Cache.setItem('coupon', code)
  }, [code])

  return null
}

Builder.registerComponent(DiscountCode, {
  name: 'DiscountCode',
  friendlyName: 'Discount Code',
  inputs: [
    {
      name: 'code',
      type: 'text',
      defaultValue: '',
      helperText: 'The discount code to apply to the whole page'
    }
  ],
  canHaveChildren: false
})
